import React from "react";
import mind from "../../../assets/images/newpages/mind.png"
import road from "../../../assets/images/newpages/road.png"

const Mind = ({heading,content}) => {
  return (
    <section className="keyzi_fullContnetWithout-bgWrapper">
      <div className="container">
        <div className="keyzi_fullContnetWithout-bgInnner">
          {content?.[0]?.description && <div dangerouslySetInnerHTML={{ __html: content?.[0]?.description }} />}
        </div>
      </div>
    </section>
  );
};

export default Mind;
